import * as React from 'react';
import { connect } from 'react-redux';
import { IDocument } from '../../../../infrastructure/interfaces';
import DocumentService from '../../../../services/DocumentService';

const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    document: state.document,
  };
};

export interface ErrorMessageProps {
  document?: IDocument;
}

@(connect(mapStateToProps, null) as any)
export default class ErrorMessage extends React.Component<ErrorMessageProps> {

  render() {
    if (this.props.document == undefined) {
      return (<div></div>);
    }

    const validationResult =DocumentService.validateDocument(this.props.document);
    const { dividersError } = validationResult;

    return (
      <div className="rightSidePane-message">
        {dividersError && dividersError.length ? `Error: Divider on left page (Page ${dividersError.join(',')}).` : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/common/ErrorMessage.tsx